import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadableComposeScreen = Loadable({
  loader: function loader() {
    return import('../ComposeScreen.jsx');
  },
  loading: ComponentLoading
});
export default LoadableComposeScreen;